// export class Module {
//   foo() {
//     return 'ダイナミック';
//   }
// }

// export default class {
//   hoge() {
//     return 'ダイナミック';
//   }
// };

// export const Hoge = {
//   hogehoge() {
//     return 'ダイナミック〜らず';
//   }
// }



export const Player = {

  foo: function() {
    return 'プレイヤーですで';
  },

   playerBlack: {
    isAI:false,
    getNextCell(state){
      let z = state.black.placeableCells.length-1;
      let c = Math.floor(Math.random () * z);
      console.log('内部Dynamic黒');
      return state.black.placeableCells[c];
    }
  },

  playerWhite: {
    isAI:false,
    getNextCell(state){
      let z = state.white.placeableCells.length-1;
      let c = Math.floor(Math.random () * z);
      console.log('内部Dynamic白');
      return state.white.placeableCells[c];
    }
  }


};


/*
下記の書き方はローカルは動くがレンサバでは動かない
上の書き書き方に変更
export class Player {

  foo() {
    return 'プレイヤーですです';
  }

  playerBlack = {
    isAI:false,
    getNextCell(state){
      let z = state.items.black.placeableCells.length-1;
      let c = Math.floor(Math.random () * z);
      console.log(c);
      return state.items.black.placeableCells[c];
    }
  };

  playerWhite = {
    isAI:false,
    getNextCell(state){
      let z = state.items.white.placeableCells.length-1;
      let c = Math.floor(Math.random () * z);
      return state.items.white.placeableCells[c];
    }
  };


};
*/